"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyExperimentSettingsToJSON = exports.CopyExperimentSettingsFromJSONTyped = exports.CopyExperimentSettingsFromJSON = exports.instanceOfCopyExperimentSettings = exports.CopyExperimentSettingsLanguagesEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.CopyExperimentSettingsLanguagesEnum = {
    EN_GB: 'en-gb',
    EN_US: 'en-us',
    DE: 'de',
    NL: 'nl',
    FR: 'fr',
    ES: 'es',
    ES_AR: 'es-ar',
    ES_MX: 'es-mx',
    CA: 'ca',
    IT: 'it',
    PT_PT: 'pt-pt',
    PT_BR: 'pt-br',
    NO: 'no',
    FI: 'fi',
    SV: 'sv',
    DA: 'da',
    CS: 'cs',
    HU: 'hu',
    RO: 'ro',
    JA: 'ja',
    ZH_CN: 'zh-cn',
    ZH_TW: 'zh-tw',
    PL: 'pl',
    EL: 'el',
    RU: 'ru',
    TR: 'tr',
    BG: 'bg',
    AR: 'ar',
    KA: 'ka',
    KO: 'ko',
    HE: 'he',
    LV: 'lv',
    UK: 'uk',
    ID: 'id',
    MS: 'ms',
    TH: 'th',
    ET: 'et',
    HR: 'hr',
    LT: 'lt',
    SK: 'sk',
    SR: 'sr',
    SL: 'sl',
    VI: 'vi',
    TL: 'tl',
    IS: 'is',
    HI: 'hi',
    UNKNOWN_DEFAULT_OPEN_API: '11184809'
};
/**
 * Check if a given object implements the CopyExperimentSettings interface.
 */
function instanceOfCopyExperimentSettings(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCopyExperimentSettings = instanceOfCopyExperimentSettings;
function CopyExperimentSettingsFromJSON(json) {
    return CopyExperimentSettingsFromJSONTyped(json, false);
}
exports.CopyExperimentSettingsFromJSON = CopyExperimentSettingsFromJSON;
function CopyExperimentSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'actions': !(0, runtime_1.exists)(json, 'actions') ? undefined : json['actions'],
        'countries': !(0, runtime_1.exists)(json, 'countries') ? undefined : json['countries'],
        'languages': !(0, runtime_1.exists)(json, 'languages') ? undefined : json['languages'],
        'onviewTracking': !(0, runtime_1.exists)(json, 'onview_tracking') ? undefined : json['onview_tracking'],
        'siteTypes': !(0, runtime_1.exists)(json, 'site_types') ? undefined : json['site_types'],
        'translations': !(0, runtime_1.exists)(json, 'translations') ? undefined : json['translations'],
        'variants': !(0, runtime_1.exists)(json, 'variants') ? undefined : json['variants'],
    };
}
exports.CopyExperimentSettingsFromJSONTyped = CopyExperimentSettingsFromJSONTyped;
function CopyExperimentSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'actions': value.actions === undefined ? undefined : Array.from(value.actions),
        'countries': value.countries === undefined ? undefined : Array.from(value.countries),
        'languages': value.languages === undefined ? undefined : Array.from(value.languages),
        'onview_tracking': value.onviewTracking,
        'site_types': value.siteTypes === undefined ? undefined : Array.from(value.siteTypes),
        'translations': value.translations,
        'variants': value.variants,
    };
}
exports.CopyExperimentSettingsToJSON = CopyExperimentSettingsToJSON;
